import { render, staticRenderFns } from "./LeftSidebarTryout.vue?vue&type=template&id=45fdeeb8&"
import script from "./LeftSidebarTryout.vue?vue&type=script&lang=js&"
export * from "./LeftSidebarTryout.vue?vue&type=script&lang=js&"
import style0 from "./LeftSidebarTryout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports